module.exports = __webpack_public_path__ + "statics/img/ycz2.9c58a61d.png";